<template>
  <div class="alert">
    <div class="image">
      <img src="../assets/attention.png" alt="Smart Image">
    </div>
    <div class="hello">

      <h1>Opps!</h1>
      <p>
        Please request for another KYC link
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alert{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.image {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.image img {
  max-width: 20%;
  height: auto;
  display: block;
}
/* Media Queries */
@media (max-width: 768px) {
  .image {
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  .image {    margin-bottom: 10px;
  }
}

</style>
